import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss'],
    imports: [ReactiveFormsModule]
})
export class SearchFilterComponent implements OnInit {
  @Input() searchForm: UntypedFormGroup;
  @Input() placeholder: string;
  constructor() { }

  ngOnInit() {
  }

}
